module.exports = __webpack_public_path__ + "img/7.925ab456.jpg";